module.exports = __webpack_public_path__ + "static/media/flask_laboratory.e16f040a.svg";